import { createRestSlice } from "./restSlice";

export type OrganizationServiceAccount = {
  id: string;
  name: string;
  description: string | null;
  permissions: string[];
  createdByUserId: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
};

const organizationServiceAccountsSlice = createRestSlice<OrganizationServiceAccount>("organizationServiceAccounts", "/v1/organization-service-accounts");

export const organizationServiceAccountsReducer = organizationServiceAccountsSlice.reducer;
export const organizationServiceAccountsActions = organizationServiceAccountsSlice.actions;
